import { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { fetchNoteSettingsRequest, updateNoteSettingsRequest } from "../../../containers/AdminPanel/features/noteSettings/noteSettingsSlice";
import { use } from "chai";

const useNoteSettings = () => {
    const [hours, setHours] = useState("")
    const [minutes, setMinutes] = useState("")
    const [hoursError, setHoursError] = useState("")
    const [minutesError, setMinutesError] = useState("")
    const dispatch = useDispatch();
    const noteSettingsUpdated = useSelector((state) => state.adminPanel.noteSettingsData.noteSettingsUpdated); 
    const noteSettings = useSelector((state) => state.adminPanel.noteSettingsData.noteSettings);
    const [showSaved, setShowSaved] = useState(false);

    useEffect(() => {
        if (noteSettingsUpdated) {
            setShowSaved(true);
            const t = setTimeout(() => setShowSaved(false), 3000);
            return () => clearTimeout(t);
        }
    }, [noteSettingsUpdated]);

    useEffect(() => {
        dispatch(fetchNoteSettingsRequest())
    }, [])

    useEffect(() => {
        if(noteSettings){
            setHours(String(noteSettings.noteHours ?? ""))
            setMinutes(String(noteSettings.noteMinutes ?? ""))
        }
    }, [noteSettings])

    const handleMinutesChange = (e) => {
        const raw = String(e.target.value || "");
        const digits = raw.replace(/\D/g, '');
        setMinutes(digits);
        setMinutesError(false)
    }
    const handleHoursChange = (e) => {
        const raw = String(e.target.value || "");
        // keep only digits and limit to 2 characters
        const digits = raw.replace(/\D/g, '').slice(0, 2);
        setHours(digits);
        setHoursError(false)
    }
    const handleSavePress = () => {
        if(checkValidations()){
            dispatch(updateNoteSettingsRequest({ noteshrs: hours, notesmin: minutes }))
        }
    }

    const checkValidations = () => {
        if(hours === ""){
            setHoursError(true)
        }
        if(minutes === ""){
            setMinutesError(true)
        }

        return !(hours === "" || minutes === "");
    }
    

    return {
        hours,
        minutes,
        handleMinutesChange,
        handleHoursChange,
        handleSavePress,
        hoursError,
        minutesError,
        noteSettings,
        noteSettingsUpdated,
        showSaved
    }
}

export default useNoteSettings;